module.exports = __webpack_public_path__ + "static/media/marseille.43707ee4.jpg";